import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PropTypes from 'prop-types';
import i18n from '../../../common/i18n';
import { route } from '../../../navigation/routes';
import Reveal from '../commons/Reveal';
import SectionHeading from '../commons/SectionHeading';
import FaqItem from '../../help/commons/FaqItem';
import { getHomeFaqGroups } from '../commons/homeData';
import {
  bodyFont, CARD_RADIUS, cardShadow, ctaOutlineSx, homeColors, sectionContentSx, sectionPadding,
} from '../style/homeStyles';

// Anticipo de las preguntas frecuentes: el acordeón y el contenido se reutilizan de Ayuda.
const AyudaHome = ({ isMobile }) => {
  const groups = getHomeFaqGroups();
  // Una sola pregunta abierta a la vez; acá arranca con la primera.
  const [expandedItem, setExpandedItem] = useState(groups[0].items[0].id);

  return (
    <Box
      component="section"
      sx={{ backgroundColor: homeColors.bg3, padding: sectionPadding(isMobile), textAlign: 'left' }}
    >
      <Box sx={sectionContentSx}>
        <SectionHeading
          eyebrow={i18n.faq}
          title={i18n.helpFaqTitle}
          titleFontSize={isMobile ? 28 : 40}
        />

        {/* Mobile: un grupo debajo del otro. Desktop: dos columnas.
            Cada tarjeta crece según su contenido: no se estiran para igualar alturas. */}
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
          gap: isMobile ? '12px' : '24px',
          alignItems: 'start',
          // FaqItem no declara fontFamily: sin esto headerStyle.css lo dejaría en Poppins.
          '&, & *': { fontFamily: bodyFont },
        }}
        >
          {groups.map((group, index) => (
            <Reveal key={group.id} delay={index * 90}>
              <Box sx={{
                backgroundColor: homeColors.white,
                borderRadius: CARD_RADIUS,
                padding: isMobile ? '4px 18px 12px' : '10px 26px 18px',
                boxShadow: cardShadow,
              }}
              >
                <Typography
                  component="h3"
                  sx={{
                    fontFamily: bodyFont,
                    fontWeight: 700,
                    fontSize: 15,
                    letterSpacing: '-0.01em',
                    color: homeColors.pink,
                    padding: '14px 0 6px',
                  }}
                >
                  {group.title}
                </Typography>
                {group.items.map((item, itemIndex) => (
                  <FaqItem
                    key={item.id}
                    question={item.question}
                    answer={item.answer}
                    expanded={expandedItem === item.id}
                    onChange={() => setExpandedItem(expandedItem === item.id ? null : item.id)}
                    isLast={itemIndex === group.items.length - 1}
                  />
                ))}
              </Box>
            </Reveal>
          ))}
        </Box>

        <Reveal delay={180}>
          <Box sx={{
            display: 'flex',
            justifyContent: isMobile ? 'center' : 'flex-start',
            marginTop: '24px',
          }}
          >
            <Button
              component="a"
              href={route.help}
              endIcon={<OpenInNewIcon />}
              sx={{
                ...ctaOutlineSx,
                fontFamily: bodyFont,
                fontSize: 16,
                width: isMobile ? '90%' : 'auto',
                minWidth: isMobile ? 0 : 190,
                // El Button de MUI le gana en especificidad a un sx puesto en el ícono.
                '& .MuiButton-endIcon > *:nth-of-type(1)': { fontSize: 20 },
              }}
            >
              {i18n.homeFaqCta}
            </Button>
          </Box>
        </Reveal>
      </Box>
    </Box>
  );
};

AyudaHome.propTypes = {
  isMobile: PropTypes.bool,
};

AyudaHome.defaultProps = {
  isMobile: false,
};

export default AyudaHome;
